import { Component, Input, OnInit, AfterViewChecked } from '@angular/core';
import { DisconnectdSaleStep } from '../../enum/DisconnectedSaleStep';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
    selector: 'pme-disconnected-sale-header',
    templateUrl: './disconnected-sale-header.component.html',
    styleUrls: ['./disconnected-sale-header.component.scss'],
    standalone: false
})
export class DisconnectedSaleHeaderComponent implements OnInit, AfterViewChecked {

  headerStep: string;
  headerStepEnum = DisconnectdSaleStep;

  constructor(
    private sessionStorageService: SessionStorageService
  ) { 
    this.headerStep = '';
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked(): void {
    this.headerStep = this.sessionStorageService.getCustomData('disconnectedSaleStep');
  }

}
